<template>
  <div v-if="isStandardProduct" class="d-flex align-items-center">
    <h6 class="d-flex align-items-center mr-2 mb-0">
      <b>Printable Version:</b>
    </h6>
    <b-button
      v-if="productState !== 'current' && productState !== 'early_live'"
      variant="outline-secondary"
      size="sm"
      class="d-flex align-items-center mr-1"
      :disabled="isGeneratingPdf"
      @click="$emit('generate-pdf', 'latest')"
    >
      <b-spinner v-if="isGeneratingPdf" small style="width:20px;height:20px;" />
      <b-img
        v-else
        :src="require('@/assets/images/icons/file-icons/adobe_pdf_icon_modern.png')"
        height="20"
        style="width: auto;"
      />
      <span
        class="ml-50 font-weight-bold text-body"
        style="position: relative; top: 2px;"
      >Latest</span>
    </b-button>
    <b-button
      variant="outline-secondary"
      size="sm"
      class="d-flex align-items-center"
      :disabled="isGeneratingPdf"
      @click="$emit('generate-pdf', 'initial')"
    >
      <b-spinner v-if="isGeneratingPdf" small style="width:20px;height:20px;" />
      <b-img
        v-else
        :src="require('@/assets/images/icons/file-icons/adobe_pdf_icon_modern.png')"
        height="20"
        style="width: auto;"
      />
      <span
        class="ml-50 font-weight-bold text-body"
        style="position: relative; top: 2px;"
      >Initial</span>
    </b-button>
  </div>
</template>

<script>
import { BButton, BImg, BSpinner } from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BImg,
    BSpinner,
  },
  props: {
    productState: {
      type: String,
      default: 'current',
    },
    isGeneratingPdf: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isStandardProduct() {
      return !['draft', 'bespoke'].includes(String(this.productState).toLowerCase())
    },
  },
}
</script>
